import React from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import TopbarProfile from './topbar/TopbarProfile';
import { SiteImageOnboarding } from '../../shared/components/domainSupport';
import useAgency from '../../shared/components/hooks/useAgency';

function LayoutOnboarding({ loggedIn, logoImage }) {
  const agencyFromUrl = useAgency();
  const theme = useSelector(state => state.theme);

  // If no logoImage provided, try to load agency logo from URL
  let finalLogoImage = logoImage;
  if (!logoImage && agencyFromUrl) {
    try {
      const isLight = theme.className.endsWith('light');
      const logoFileName = isLight ? 'logo_light.png' : 'logo_dark.png';
      // eslint-disable-next-line
      finalLogoImage = require(`../../shared/img/logo/${agencyFromUrl}/${logoFileName}`);
    } catch (error) {
      // Logo file doesn't exist, use platform default
      finalLogoImage = null;
    }
  }

  return (
    <div>
      <div className="topbar_onboarding">
        <div className="topbar__right">
          {loggedIn && (
            <TopbarProfile />
          )}
        </div>
        <SiteImageOnboarding logoImage={finalLogoImage} logoHeight="100" logoWidth="300" link="/" />
      </div>
      <br /><br />
    </div>
  );
}

LayoutOnboarding.propTypes = {
  loggedIn: PropTypes.bool,
  logoImage: PropTypes.string,
};

LayoutOnboarding.defaultProps = {
  loggedIn: false,
  logoImage: null,
};

const mapStateToProps = (state) => {
  const { loggedIn } = state.authentication;
  return {
    loggedIn,
  };
};

export default connect(mapStateToProps)(LayoutOnboarding);
